import { Injectable } from '@angular/core';
import { ApplicationStage, MessageService } from 'common';
import { actionErrorMessage } from './not-interested-action-data';
import { BrokerStatus } from '@partner/shared/SharedConstants';
import { SubmissionsFacade } from '../../domain/+state/submissions.facade';
import { NotInterestedActionCompletedData, NotInterestedActionInputData } from './not-interested-action.model';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotInterestedDialogData, NotInterestedDialogResult } from '../not-interested-dialog/not-interested-dialog.model';
import { SaveApplicationData } from '../../domain/models/application.model';

@Injectable()
export class NotInterestedActionFacade {
  constructor(
    private readonly facade: SubmissionsFacade,
    private readonly messageService: MessageService,
  ) { }

  public checkIfIsActionAvailable(data: NotInterestedActionInputData) {
    switch (data?.brokerStatus) {
      case BrokerStatus.PROCESSING:
      case BrokerStatus.NOT_INTERESTED:
      case BrokerStatus.OFFER:
      case BrokerStatus.CONDITIONAL_OFFER:
      case BrokerStatus.CONTRACT_READY:
      case BrokerStatus.CONTRACT_OUT:
      case BrokerStatus.CLOSING:
      case BrokerStatus.CLOSING_INCOMPLETE:
      case BrokerStatus.DRAFT:
      case BrokerStatus.SUBMISSION_INCOMPLETE:
        return true;

      default:
        return false;
    }
  }

  public updateApplicationData(applicationId: number, data: SaveApplicationData, successMessage: string): Observable<Partial<NotInterestedActionCompletedData>> {
    return this.facade.updateApplicationData(applicationId, data)
      .pipe(map(() => {
        this.messageService.success(successMessage);
        return {
          isSuccess: true
        };
      }), catchError(() => {
        this.messageService.error(actionErrorMessage);
        return of({
          isSuccess: false,
        });
      }))
  }

  public getNotInterestedDialogData(): Observable<NotInterestedDialogData> {
    return this.facade.getNotInterestedDialogData();
  }

  public prepareSaveApplicationDataFromDialogResult(result: NotInterestedDialogResult): SaveApplicationData {
    const data: SaveApplicationData = {
      stage: ApplicationStage.NotInterested,
      lostReason: result.notInterestedReason,
    };

    if (result.competitorId) {
      data.competitorId = result.competitorId;
    }

    if (result.additionalComment) {
      data.lostReasonAdditionalComments = result.additionalComment;
    }

    return data;
  }
}
